import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api";
import type { Omc } from "@/types/api";

const AUTO_REFRESH_MS = 5 * 60 * 1000;

/** I 5 Obiettivi Misurabili Concordati, risolti (AUTO live, MANUALE da DB). */
export function useOmc() {
  return useQuery({
    queryKey: ["omc"],
    queryFn: () => apiFetch<Omc[]>("/api/v1/omc"),
    staleTime: 60_000,
    refetchInterval: AUTO_REFRESH_MS,
  });
}
